import React, {useEffect} from "react"
import {Table, Tbody, Td, Th, Thead, Tr} from "react-super-responsive-table"
import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css"

import ProgressView from "../ProgressView"
import {Link} from "react-router-dom"
import useBusinesses from "../../hooks/useBusinesses"

const BusinessesTable = ({active}) => {

    const {loadBusinesses, isLoading, businesses} = useBusinesses()

    useEffect(() => {
        loadBusinesses(false, "", active)
    }, [active])

    return <>

        {isLoading &&
        <div className={"p-2 text-center"}>
            <ProgressView/>
        </div>
        }

        {!isLoading && businesses.length === 0 &&
        <div className={"p-2 text-center"}>
            <p className="mb-2 text-muted">No data available at the moment</p>
        </div>
        }

        {!isLoading && businesses.length > 0 &&
        <div className="table-rep-plugin">
            <div
                className="table-responsive mb-0"
                data-pattern="priority-columns"
            >
                <Table
                    className="table table-striped table-bordered"
                >
                    <Thead>
                        <Tr>
                            <Th>Name</Th>
                            <Th>Type</Th>
                            <Th></Th>
                        </Tr>
                    </Thead>
                    <Tbody>
                        {businesses.map((a, b) =>
                            <Tr key={b.toString()}>
                                <Th>
                                    {a.name}
                                </Th>
                                <Th>
                                    {a?.business_type ?? 0}
                                </Th>
                                <Td>
                                    <Link to={"/dashboard/businesses/" + a.id}
                                          className="btn btn-primary btn-rounded waves-effect waves-light btn-sm">
                                        Details
                                    </Link>
                                </Td>
                            </Tr>
                        )}
                    </Tbody>

                </Table>
            </div>
        </div>
        }
    </>

}

export default BusinessesTable
